import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { FilterFacet } from '@apps/stays/components/filters/FilterFacet';
import { StyledCheckboxV2 } from '@apps/stays/components/filters/StyledCheckboxV2';

interface Facility {
  label: string;
}

interface FacilitiesFacetProps {
  title: string;
  facilities: ReadonlyArray<Facility>;
  selectedFacilities: ReadonlyArray<string>;
  facilityCounts: Readonly<Record<string, number>>;
  onFacilityToggle: (facility: string) => void;
}

export const FacilitiesFacet: React.FC<FacilitiesFacetProps> = ({ title, facilities, selectedFacilities, facilityCounts, onFacilityToggle }) => {
  return (
    <FilterFacet title={title}>
      <Flex
        flexDirection="column"
        gap={5}
      >
        {facilities.map(facility => (
          <StyledCheckboxV2
            key={facility.label}
            isChecked={selectedFacilities?.includes(facility.label) || false}
            onChange={() => onFacilityToggle(facility.label)}
            id={`facility-${facility.label}`}
            isDisabled={!facilityCounts[facility.label]}
          >
            <TextV2
              typographyVariant="body1"
              color="mono14"
            >
              {facility.label}
              {'\u00A0'}
              <TextV2
                as="span"
                typographyVariant="body1"
                color="mono10"
              >
                ({facilityCounts[facility.label]})
              </TextV2>
            </TextV2>
          </StyledCheckboxV2>
        ))}
      </Flex>
    </FilterFacet>
  );
};
